import React from 'react';
import { useTranslation } from 'react-i18next';

interface SponsorBadgeProps {
  variant?: 'inline' | 'card' | 'footer';
}

const SPONSOR_URL = 'https://beddamatri.shop/';

export const SponsorBadge: React.FC<SponsorBadgeProps> = ({ variant = 'inline' }) => {
  const { t } = useTranslation();

  if (variant === 'footer') {
    return (
      <div className="py-3 text-center">
        <span className="text-[11px] text-muted-foreground/70 font-medium">
          {t('common.sponsor')}{' '}
          <a
            href={SPONSOR_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-primary/70 hover:text-primary underline underline-offset-2 decoration-primary/30 transition-colors"
          >
            Bedda Matri
          </a>
          {' '}&mdash; {t('common.sponsorTagline')}
        </span>
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <a
        href={SPONSOR_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="block bg-white rounded-2xl border border-border p-4 hover:shadow-[0_8px_24px_rgba(194,24,91,0.10)] hover:-translate-y-0.5 transition-all group"
      >
        <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-muted-foreground mb-2">
          {t('common.sponsor')}
        </p>
        <div className="flex items-center gap-3 mb-2.5">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-amber-100 to-amber-50 border border-amber-200/60 flex items-center justify-center flex-shrink-0">
            <span className="text-base leading-none" aria-hidden="true">&#10022;</span>
          </div>
          <div className="min-w-0">
            <span className="font-serif italic text-base font-bold text-foreground group-hover:text-primary transition-colors">
              Bedda Matri
            </span>
            <p className="text-[10px] text-muted-foreground font-medium leading-tight">
              {t('common.sponsorDesc')}
            </p>
          </div>
        </div>
        <p className="text-[10.5px] text-muted-foreground/80 leading-relaxed italic">
          "Dal cuore della Sicilia, con amore"
        </p>
        <div className="mt-2.5 flex items-center gap-1.5 text-[10px] font-bold text-primary/70 group-hover:text-primary transition-colors">
          <span>{t('common.visitShop')}</span>
          <svg className="w-3 h-3 transition-transform group-hover:translate-x-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </div>
      </a>
    );
  }

  // inline
  return (
    <a
      href={SPONSOR_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-secondary/60 hover:bg-secondary border border-border/60 transition-all text-[10px] font-semibold text-muted-foreground hover:text-primary group"
      title="Bedda Matri"
    >
      <span className="text-xs leading-none" aria-hidden="true">&#10022;</span>
      <span className="hidden sm:inline">{t('common.sponsor')}:</span>
      <span className="font-bold text-foreground group-hover:text-primary transition-colors">
        Bedda Matri
      </span>
    </a>
  );
};
